import Widget from './Widget';

export { Widget };
